export default __webpack_public_path__ + "static/media/kyykka_3.43b6cfcb.jpg";